// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"650":"8ae836f1","737":"0ec72daa"}[chunkId] + ".css";
};